<template>
    <section
        class="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8"
        aria-labelledby="inline-cta-heading"
    >
        <div class="rounded-xl border border-slate-200 bg-slate-50 p-6 sm:p-8">
            <div
                class="flex flex-col items-center gap-4 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left"
            >
                <div>
                    <h2
                        id="inline-cta-heading"
                        class="text-lg font-bold"
                    >
                        {{ title }}
                    </h2>
                    <p class="mt-1 text-slate-600">{{ subtitle }}</p>
                </div>

                <div
                    class="flex flex-row items-center gap-2 sm:flex-row sm:items-stretch"
                >
                    <a
                        :href="primaryButtonUrl"
                        class="rounded-lg2 bg-primary px-5 py-3 text-center text-base font-bold text-white shadow-xs shadow-primary-shade-ligth hover:bg-primary-shade"
                    >
                        {{ primaryButtonLabel }}
                    </a>
                    <a
                        v-if="
                            secondaryButtonLabel !== null &&
                            secondaryButtonUrl !== null
                        "
                        :href="secondaryButtonUrl"
                        class="rounded-lg2 border border-slate-200 bg-white px-5 py-3 text-center text-base font-bold text-slate-800 hover:bg-slate-50"
                    >
                        {{ secondaryButtonLabel }}
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    interface CallToActionProps {
        title: string
        subtitle: string
        primaryButtonLabel: string
        primaryButtonUrl: string
        secondaryButtonLabel?: string | null
        secondaryButtonUrl?: string | null
    }

    const props = withDefaults(defineProps<CallToActionProps>(), {
        secondaryButtonLabel: null,
        secondaryButtonUrl: null,
    })
</script>
